import axios, { AxiosInstance, InternalAxiosRequestConfig, AxiosHeaders } from 'axios';
import { msalInstance } from '@/modules/authentication/msalInstance';

export class AxioClient {
  public static api(baseUrl: string, scopes: string[], timeout: number): AxiosInstance {
    const result = axios.create({
      baseURL: baseUrl,
      timeout,
    });

    result.interceptors.request.use(
      async (config: InternalAxiosRequestConfig) => {
        const account = msalInstance.getActiveAccount() ?? msalInstance.getAllAccounts()[0];

        if (!account) {
          return config;
        }

        if (!msalInstance.getActiveAccount()) {
          msalInstance.setActiveAccount(account);
        }

        const tokenResponse = await msalInstance.acquireTokenSilent({
          scopes,
          account,
        });

        const headers = AxiosHeaders.from(config.headers);
        headers.set('Authorization', `Bearer ${tokenResponse.accessToken}`);
        config.headers = headers;

        return config;
      },
      (error) => Promise.reject(error),
    );

    return result;
  }
}
